





















import OrgService from '@/api/org.service';
import { SET_ORG_DETAILS, STORE_DUNNING_SETTINGS } from '@/store/mutation-types';
import { IDunning, IUser } from '@/store/types';
import Vue from 'vue';

export default Vue.extend({
  name: 'SettingsDunningBcc',
  data() {
    return {
      team: [] as IUser[],
      loading: false,
    };
  },
  async created() {
    this.fetchMembers();
    this.loading = false;
  },
  computed: {
    dunning(): IDunning {
      return this.$store.state.org?.dunning || {};
    },
    bcc(): string[] {
      return this.dunning?.bcc || [];
    },
  },
  methods: {
    async save() {
      await OrgService.updateDunningSettings(this.$store.state.org._id, { bcc: this.bcc });
    },
    update(bcc: string[]) {
      this.$store.commit(STORE_DUNNING_SETTINGS, { bcc });
      this.save();
    },
    async fetchMembers() {
      try {
        this.team = await OrgService.getMembers(this.$store.state.user.org);
      } catch (error) {
        console.log(error);
      }
    },
  },
});
